"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import {
  LayoutDashboard,
  CalendarDays,
  Drama,
  UsersRound,
  BookOpen,
  Users,
  Settings,
  Menu,
  X,
} from "lucide-react";
import { useState } from "react";

const menu = [
  { label: "Tableau de bord", icon: LayoutDashboard, href: "/" },
  { label: "Festivals", icon: CalendarDays, href: "/festivals" },
  { label: "Spectacles", icon: Drama, href: "/spectacles" },
  { label: "Troupes / Artistes", icon: UsersRound, href: "/troupes-artistes" },
  { label: "Référentiels", icon: BookOpen, href: "/referentiels" },
  { label: "Utilisateurs", icon: Users, href: "/utilisateurs" },
  { label: "Administration", icon: Settings, href: "/administration" },
];

function titleForPath(pathname: string) {
  if (pathname.startsWith("/troupes-artistes")) return "Troupes / Artistes";
  if (pathname.startsWith("/spectacles")) return "Spectacles";
  if (pathname.startsWith("/festivals")) return "Festivals";
  if (pathname.startsWith("/referentiels")) return "Référentiels";
  if (pathname.startsWith("/utilisateurs")) return "Utilisateurs";
  if (pathname.startsWith("/administration")) return "Administration";
  return "Tableau de bord";
}

export default function AdminShell({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  const pathname = usePathname();
  const title = titleForPath(pathname);

  return (
    <div className="admin">
      <aside className={`sidebar ${open ? "open" : ""}`}>
        <div className="brand">
          <div className="route">
            <span className="route-dot teal" />
            <span className="route-line" />
            <span className="route-dot orange" />
            <span className="route-line short" />
            <span className="route-dot pink" />
          </div>
          <div className="brand-name">festi<span>Tempo</span></div>
          <div className="brand-sub">Administration</div>
        </div>

        <button className="close-mobile" onClick={() => setOpen(false)} aria-label="Fermer">
          <X size={22} />
        </button>

        <nav>
          {menu.map((item) => {
            const Icon = item.icon;
            const active =
              item.href === "/"
                ? pathname === "/"
                : pathname === item.href || pathname.startsWith(item.href + "/");
            return (
              <Link
                href={item.href}
                onClick={() => setOpen(false)}
                className={active ? "nav-item active" : "nav-item"}
                key={item.href}
              >
                <Icon size={19} />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="sidebar-bottom">
          <div className="user-circle">FT</div>
          <div>
            <strong>FestiTempo</strong>
            <span>Super administrateur</span>
          </div>
        </div>
      </aside>

      {open && <div className="overlay" onClick={() => setOpen(false)} />}

      <main className="main">
        <header className="topbar">
          <button className="menu-mobile" onClick={() => setOpen(true)} aria-label="Menu">
            <Menu size={23} />
          </button>
          <div>
            <div className="breadcrumb">FestiTempo / {title}</div>
            <h1>{title}</h1>
          </div>
          <div className="status"><span /> Plateforme active</div>
        </header>
        <div className="content">{children}</div>
      </main>
    </div>
  );
}
